import { render, staticRenderFns } from "./materialManage.vue?vue&type=template&id=491f7913&scoped=true"
import script from "./materialManage.vue?vue&type=script&lang=js"
export * from "./materialManage.vue?vue&type=script&lang=js"
import style0 from "./materialManage.vue?vue&type=style&index=0&id=491f7913&prod&lang=less&scoped=true"
import style1 from "./materialManage.vue?vue&type=style&index=1&id=491f7913&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491f7913",
  null
  
)

export default component.exports